import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {entityCardsFeatureKey, reducer} from './entity-card.reducer';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(entityCardsFeatureKey, reducer),
  ],
})
export class EntityCardModule {
}
